/** Maintenance April 2026 (browser local time) */
export const MAINTENANCE_YEAR = 2026;
export const APRIL = 3; // 0-indexed
export const START_MAINTENANCE_DAY = 2;
export const END_MAINTENANCE_DAY = 6;



export function isPreMaintenance(now = new Date()) {
  const startActive = new Date(MAINTENANCE_YEAR, APRIL, START_MAINTENANCE_DAY, 0, 0, 0, 0);
  return now < startActive;
}

export function isDuringMaintenance(now = new Date()) {
  const startActive = new Date(MAINTENANCE_YEAR, APRIL, START_MAINTENANCE_DAY, 0, 0, 0, 0);
  const afterMaintenance = new Date(MAINTENANCE_YEAR, APRIL, END_MAINTENANCE_DAY, 0, 0, 0, 0);
  return now >= startActive && now < afterMaintenance;
}

export function isAfterMaintenance(now = new Date()) {
  const afterMaintenance = new Date(MAINTENANCE_YEAR, APRIL, END_MAINTENANCE_DAY, 0, 0, 0, 0);
  return now >= afterMaintenance;
}